import React, { useLayoutEffect } from 'react';
import {
    Grid,
    GridProps,
    Spacer,
    Text,
} from '@chakra-ui/react';
import {
    Image,
    RichText,
    useAppDispath,
} from 'shared';
import { useParams } from 'react-router-dom';
import { CartAddButtonWithCounter, LeadSmallSection } from 'features';
// eslint-disable-next-line no-restricted-imports
import { Carousel } from 'shared/ui/Carousel';
import { Helmet } from 'react-helmet-async';
// eslint-disable-next-line no-restricted-imports
import { richTextToString } from 'shared/lib/richtext-to-string';
import { SweetShopArticlePageActions, useSweetShopArticlePageState } from '../../store';
import { SweetShopArticlePageMainHeader } from './SweetShopArticlePageMainHeader';
import { SweetShopArticlePageMainElementsSection } from './SweetShopArticlePageMainElementsSection';
import { SweetShopArticlePageMainRecommendationsSection } from './SweetShopArticlePageMainRecommendationsSection';

export type SweetShopArticlePageMainProps = GridProps & React.RefAttributes<HTMLDivElement>

export const SweetShopArticlePageMain: React.FC<SweetShopArticlePageMainProps> = ({
    ...props
}) => {
    const dispatch = useAppDispath();
    const { id } = useParams();
    const { sweetShopArticle, leadFormPdf } = useSweetShopArticlePageState();

    useLayoutEffect(() => {
        if (id) {
            dispatch(SweetShopArticlePageActions.getSweetShopArticleByUid({
                uid: id,
            }));
        }
    }, [id]);

    return id ? (
        <Grid
            {...props}
        >
            <Helmet>
                <title>{sweetShopArticle?.name}</title>
                <meta name="description" content={richTextToString(sweetShopArticle?.description)} />
                <meta property="og:title" content={sweetShopArticle?.name} />
            </Helmet>
            <SweetShopArticlePageMainHeader
                title={sweetShopArticle?.name || ''}
                padding="2rem 2rem 0 2rem"
                maxWidth={{
                    base: '425px',
                    lg: '1280px',
                }}
                width="100%"
                margin="0 auto"
                gap="2rem"
                background="white"
            />
            <Grid
                templateColumns={{
                    base: '1fr',
                    lg: '1fr 1fr',
                }}
                padding="2rem"
                gap="2rem"
                maxWidth={{
                    base: '425px',
                    lg: '1280px',
                }}
                background="white"
                width="100%"
                margin="0 auto"
            >
                <Carousel
                    maxWidth={{
                        base: '425px',
                        lg: '1280px',
                    }}
                    width="100%"
                    margin="0 auto"
                    background="white"
                    withDialog
                    items={sweetShopArticle?.images?.map(({ url }) => (
                        <Image aspectRatio="1 / 1" width="100%" objectFit="cover" src={url} />
                    )) || []}
                />
                <Grid
                    gap="2rem"
                    templateRows={sweetShopArticle?.elements ? 'auto 1fr auto' : '1fr auto'}
                >
                    {sweetShopArticle?.elements && (
                        <SweetShopArticlePageMainElementsSection
                            elements={sweetShopArticle?.elements || []}
                        />
                    )}
                    <RichText
                        content={sweetShopArticle?.description}
                    />
                    <Grid
                        templateColumns="1fr auto"
                    >
                        <Grid>
                            {sweetShopArticle?.weight ? (
                                <Text
                                    fontSize="1rem"
                                >
                                    Вес:
                                    {' '}
                                    {sweetShopArticle?.weight}
                                    г
                                </Text>
                            ) : (
                                <Spacer />
                            )}
                            <Text fontSize="2rem" fontWeight={900}>
                                {sweetShopArticle?.price ? (
                                    sweetShopArticle.price.toLocaleString()
                                + (sweetShopArticle?.currency?.abbreviation || '')
                                ) : (
                                    'Цена не указана'
                                )}
                            </Text>
                        </Grid>
                        <CartAddButtonWithCounter
                            type="delivery"
                            uid={id}
                        />
                    </Grid>
                </Grid>
            </Grid>
            <Grid
                background="#000000"
            >
                <LeadSmallSection
                    title="НЕ МОЖЕТЕ ОПРЕДЕЛИТЬСЯ?"
                    padding="2rem"
                    buttonText="Заказать звонок"
                    background="#000000"
                    maxWidth={{
                        base: '425px',
                        lg: '1280px',
                    }}
                    width="100%"
                    margin="0 auto"
                    pdfUrl={leadFormPdf?.url}
                />
            </Grid>
            {sweetShopArticle?.recommendations && sweetShopArticle?.recommendations.length > 0 && (
                <SweetShopArticlePageMainRecommendationsSection
                    padding="2rem"
                    sweetShopArticleRecommendations={sweetShopArticle.recommendations}
                    maxWidth={{
                        base: '425px',
                        lg: '1280px',
                    }}
                    background="white"
                    width="100%"
                    margin="0 auto"
                />
            )}
        </Grid>
    ) : null;
};
